import { render, staticRenderFns } from "./WithPhones.vue?vue&type=template&id=13964782&scoped=true&"
import script from "./WithPhones.vue?vue&type=script&lang=ts&"
export * from "./WithPhones.vue?vue&type=script&lang=ts&"
import style0 from "./WithPhones.vue?vue&type=style&index=0&id=13964782&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13964782",
  null
  
)

export default component.exports